var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 7.99935C3.4665 8.66602 4.2665 9.33268 5.99984 9.33268C9.33317 9.33268 9.33317 6.66602 12.6665 6.66602C16.1332 6.66602 15.8665 9.33268 19.3332 9.33268C22.6665 9.33268 22.6665 6.66602 25.9998 6.66602C27.7332 6.66602 28.5332 7.33268 29.3332 7.99935M2.6665 15.9993C3.4665 16.666 4.2665 17.3327 5.99984 17.3327C9.33317 17.3327 9.33317 14.666 12.6665 14.666C16.1332 14.666 15.8665 17.3327 19.3332 17.3327C22.6665 17.3327 22.6665 14.666 25.9998 14.666C27.7332 14.666 28.5332 15.3327 29.3332 15.9993M2.6665 23.9993C3.4665 24.666 4.2665 25.3327 5.99984 25.3327C9.33317 25.3327 9.33317 22.666 12.6665 22.666C16.1332 22.666 15.8665 25.3327 19.3332 25.3327C22.6665 25.3327 22.6665 22.666 25.9998 22.666C27.7332 22.666 28.5332 23.3327 29.3332 23.9993",
    stroke: "#33894E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup);
export default __webpack_public_path__ + "static/media/SUP.bceb7a9f652da0b7e59b16d5b7dc464c.svg";
export { ForwardRef as ReactComponent };